"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const antd_1 = require("antd");
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const response_codes_1 = require("../../assets/constants/response_codes");
const HeaderMenuComponent_1 = __importDefault(require("../../components/headerMenuComponent/HeaderMenuComponent"));
const user_requests_1 = require("../../dataSource/user_requests");
const RoutesPaths_1 = require("../../routes/RoutesPaths");
const detectDevice_1 = __importDefault(require("../../utils/detectDevice"));
const helpers_1 = require("../../utils/helpers");
const logoutUser_1 = require("../../utils/logoutUser");
const message_utils_1 = __importDefault(require("../../utils/message_utils"));
const HomeFooter_1 = __importDefault(require("../home/homeFooter/HomeFooter"));
const AccountInfoStyles_1 = require("./AccountInfoStyles");
const Perfil_1 = __importDefault(require("./perfil/Perfil"));
const Reserves_1 = __importDefault(require("./reserves/Reserves"));
const Services_1 = __importDefault(require("./services/Services"));
const Maintenance_1 = __importDefault(require("./services/maintenance/Maintenance"));
const MaintenanceList_1 = __importDefault(require("./services/maintenanceList/MaintenanceList"));
const SideMenu_1 = __importDefault(require("./sideMenu/SideMenu"));
const storage_1 = require("../../utils/storage");
const MOBILE_WIDTH = 992;
const MEDIUM_SCREEN_WIDTH = 1500;
const LARGE_CONTENT = 24;
const MEDIUM_CONTENT = 20;
const SMALL_CONTENT = 17;
const LARGE_SIDEMENU = 24;
const MEDIUM_SIDEMENU = 7;
const SMALL_SIDEMENU = 4;
const AccountInfo = () => {
    const { subPath } = (0, react_router_dom_1.useRouteMatch)().params;
    const history = (0, react_router_dom_1.useHistory)();
    const [actualUser, setActualUser] = (0, react_1.useState)({});
    const { width } = (0, detectDevice_1.default)(MOBILE_WIDTH);
    const ContentFactory = {
        perfil: react_1.default.createElement(Perfil_1.default, { actualUser: actualUser }),
        reservas: react_1.default.createElement(Reserves_1.default, null),
        servicos: react_1.default.createElement(Services_1.default, null),
        manutencao: react_1.default.createElement(Maintenance_1.default, null),
        solicitacoes: react_1.default.createElement(MaintenanceList_1.default, null),
    };
    (0, react_1.useEffect)(() => {
        if (!subPath) {
            history.push('/minha-conta/perfil');
        }
    }, [subPath, history]);
    (0, react_1.useEffect)(() => {
        if (!Object.values(actualUser).length) {
            (() => __awaiter(void 0, void 0, void 0, function* () {
                const loggedUser = yield (0, user_requests_1.getMyProfile)();
                if (loggedUser.code === response_codes_1.GetMyProfileCodes.SUCCESS &&
                    JSON.stringify(loggedUser.user) !== JSON.stringify(actualUser)) {
                    setActualUser(loggedUser.user);
                    localStorage.setItem('USER_INFO', (0, helpers_1.encrypty)(JSON.stringify(actualUser)));
                }
                else if (loggedUser.code === response_codes_1.GetMyProfileCodes.UNAUTHORIZED) {
                    (0, logoutUser_1.handleLogout)(history, RoutesPaths_1.routesPaths.login);
                    message_utils_1.default.error({ message: 'Sessão Expirada' });
                }
            }))();
        }
    }, [subPath, actualUser, history]);
    (0, react_1.useEffect)(() => {
        const tmpUser = (0, storage_1.getStorageValue)('USER_INFO');
        if (tmpUser)
            setActualUser(JSON.parse(tmpUser));
    }, []);
    const getColSpan = (0, react_1.useCallback)(() => {
        if (width <= MOBILE_WIDTH)
            return [LARGE_SIDEMENU, LARGE_CONTENT];
        if (width > MOBILE_WIDTH && width < MEDIUM_SCREEN_WIDTH)
            return [MEDIUM_SIDEMENU, SMALL_CONTENT];
        return [SMALL_SIDEMENU, MEDIUM_CONTENT];
    }, [width]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(HeaderMenuComponent_1.default, null),
        react_1.default.createElement(AccountInfoStyles_1.ContainerBody, null,
            react_1.default.createElement(antd_1.Col, { span: getColSpan()[0] },
                react_1.default.createElement(SideMenu_1.default, { name: actualUser.firstName || '' })),
            react_1.default.createElement(antd_1.Col, { span: getColSpan()[1] }, ContentFactory[subPath])),
        react_1.default.createElement(HomeFooter_1.default, null)));
};
exports.default = AccountInfo;
